import React from 'react';
import {
  Toggle,
  SelectField,
  MenuItem,
} from 'material-ui';
import { translate as t } from 'admin-on-rest';
import TranslatableInput from './inputs/TranslatableInput';
import blockComponents, { lookupTable } from './index';

class ImageAndText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textAlignValue: this.props.values ? this.props.values.textAlignValue : '',
    };
  }

  handleTextAlignChange = (event, index, value) => {
    this.setState({ textAlignValue: value });
    this.props.onChange('textAlign', this.props.id, value);
  }

  render() {
    const { onChange, id, values, translate } = this.props;
    return (
      <div className="image-and-text">

        <span className="block-type">
          <span className="title">
            <lookupTable.heading.icon />
            <span className="title">{translate('website.blockHeading')}</span>
          </span>
        </span>
        <blockComponents.heading prefix="heading" onChange={onChange} id={id} values={this.props.values ? this.props.values.heading : ''} />

        <Toggle
          className="block-field toggle"
          label={translate('website.standardLayout')}
          labelPosition="right"
          name="standardLayout"
          defaultToggled={this.props.values && this.props.values.standardLayout ? this.props.values.standardLayout : false}
          onToggle={(e, val) => onChange('standardLayout', id, val)}
        />
        <span className="block-field">
          <SelectField
            onChange={this.handleTextAlignChange}
            value={this.state.textAlignValue}
            name="textAlign"
            floatingLabelText={translate('website.textAlign')}
            fullWidth
          >
            <MenuItem value="center" primaryText="Center" />
            <MenuItem value="top" primaryText="Top" />
          </SelectField>
        </span>
        <br />

        <span className="block-type">
          <span className="title">
            <lookupTable.heading.icon />
            <span className="title">{translate('website.blockCopy')}</span>
          </span>
        </span>
        <TranslatableInput
          id={id}
          values={values && values.text}
          name="text"
          options={{ multiline: true, basic: false }}
          label={translate('website.bodyText')}
          onChange={(val) => onChange('text', id, val)}
        />

        <span className="block-type">
          <span className="title">
            <lookupTable.image.icon />
            <span className="title">{translate('website.blockImage')}</span>
          </span>
        </span>
        <blockComponents.image prefix="image" onChange={onChange} id={id} values={this.props.values ? this.props.values.image : ''} />

        <span className="block-type">
          <span className="title">
            <lookupTable.button.icon />
            <span className="title">{translate('website.blockButton')}</span>
          </span>
        </span>
        <blockComponents.button prefix="button" onChange={onChange} id={id} values={this.props.values ? this.props.values.button : ''} />
      </div>
    );
  }
}

export default t(ImageAndText);
